import EnquiryForm from "../components/common/EnquiryForm";

const sections = [
  {
    number: "1",
    title: "General Responsibilities",
    subsections: [
      {
        number: "1.1",
        title: "Conduct and Use",
        items: [
          "1.1.1 The premises are to be used for commercial purposes only.",
          "1.1.2 Under no circumstances is residential use permitted.",
          "1.1.3 Tenants must comply with all relevant planning regulations. It is the responsibility of the Tenant to ensure the correct use class applies to their activity and to carry out due diligence before commencing operations.",
          "1.1.4 The landlord and/or Managing Agent does not offer planning advice and cannot be held responsible for a Tenant's breach of planning.",
        ],
      },
      {
        number: "1.2",
        title: "Legal and Regulatory Compliance",
        items: [
          "1.2.1 Tenants must not conduct any unlawful, dangerous, or disruptive activity within the building.",
          "1.2.2 All activity must comply with employment law. If Tenants employ staff, they are responsible for ensuring the space is suitable and compliant for employment.",
          "1.2.3 The landlord provides a blank commercial space. It is the Tenant's responsibility to ensure that the environment is suitable for their business and their team.",
        ],
      },
      {
        number: "1.3",
        title: "Visitors and Guests",
        items: [
          "1.3.1 Tenants must manage the number and behaviour of guests, contractors, or visitors so as not to overburden communal facilities or disturb other users.",
          "1.3.2 Tenants are responsible for the conduct of any visitors they permit into the building.",
        ],
      },
    ],
  },
  {
    number: "2",
    title: "Unit Conditions and Alterations",
    subsections: [
      {
        number: "2.1",
        title: "Studio Condition and Fit Out",
        items: [
          "2.1.1 All studios are let in a \"shell and core\" or \"as seen\" condition.",
          "2.1.2 No credits or compensation are offered for cosmetic conditions within the studio.",
          "2.1.3 Tenants may make changes only upon written approval via a completed and authorised Studio Alterations Form (SAF).",
        ],
      },
      {
        number: "2.2",
        title: "Alteration Rules",
        items: [
          "2.2.1 No alterations (including partitioning, painting, installation of fittings or services) are permitted without prior SAF approval.",
          "2.2.2 Approved alterations must be: (a) Undertaken by competent persons; (b) Compliant with UK Building Regulations; (c) Removed at the end of the tenancy unless otherwise agreed.",
        ],
      },
      {
        number: "2.3",
        title: "Fire Doors and Signage",
        items: [
          "2.3.1 All doors are fire-rated and must not be altered in any way.",
          "2.3.2 No signage, stickers or fixings are permitted on any door.",
          "2.3.3 Some buildings provide an A6 acrylic sign holder beside studio doors for Tenant branding. No other signage may be displayed on communal walls or external façades without prior written permission.",
        ],
      },
      {
        number: "2.4",
        title: "Blinds and Curtains",
        items: [
          "2.4.1 Where applicable, permission for the installation of blinds or curtains will be provided via a Studio Alterations Form (SAF).",
          "2.4.2 Any blinds or curtains installed must be plain white or black-lined, so that no pattern, colour or design is visible from the exterior.",
        ],
      },
      {
        number: "2.5",
        title: "Painting of Exposed Concrete Surfaces",
        items: [
          "2.5.1 It is strictly forbidden to paint original exposed concrete surfaces within the units.",
          "2.5.2 No permission will be granted for alterations to exposed concrete, as such works are deemed irreversible and cannot be restored to the original condition.",
        ],
      },
    ],
  },
  {
    number: "3",
    title: "Waste and Communal Areas",
    subsections: [
      {
        number: "3.1",
        title: "Waste Disposal",
        items: [
          "3.1.1 Waste facilities are provided for small, office-style waste only.",
          "3.1.2 Construction waste, large items, pallets, appliances, or hazardous materials must not be placed in or near the bin store.",
          "3.1.3 It is the Tenant's responsibility to arrange disposal of non-standard waste via a licensed contractor.",
          "3.1.4 Waste must be placed inside bins only. Waste left outside bins or outside studios is strictly prohibited.",
        ],
      },
      {
        number: "3.2",
        title: "Enforcement for Breaches",
        items: [
          "3.2.1 Items or waste found in breach of policy may result in: (a) Penalty charges; (b) Removal at the Tenant's cost; (c) Reimbursement for associated administrative or contractor fees.",
        ],
      },
      {
        number: "3.3",
        title: "Communal Cleanliness",
        items: [
          "3.3.1 Communal areas (corridors, toilets, tea-points) must be kept clean and free from obstruction.",
          "3.3.2 Tenants must not store bins or items in communal areas.",
          "3.3.3 Cleaning contractors are not responsible for removing studio waste. Abuse of cleaning services may lead to enforcement action.",
        ],
      },
      {
        number: "3.4",
        title: "Wet Wipes and Drain Misuse",
        items: [
          "3.4.1 There is zero tolerance for wet wipes, sanitary products, coffee grounds, oil or food waste in any drains or toilets.",
          "3.4.2 Tenants are liable for any blockages or damage caused.",
        ],
      },
    ],
  },
  {
    number: "4",
    title: "Energy Use and Fair Usage Policy",
    subsections: [
      {
        number: "4.1",
        title: "Electricity and Heating",
        items: [
          "4.1.1 Electricity usage is covered under the service charge based on fair usage.",
          "4.1.2 Excessive use may result in: (a) A power audit; (b) Additional charges based on excess consumption; (c) In some cases, a revised lease where electricity is billed separately.",
        ],
      },
      {
        number: "4.2",
        title: "Permitted Heating Types",
        items: [
          "4.2.1 Where Tenants supply their own heating, only infrared, ceramic or liquid-filled electric heaters are permitted.",
          "4.2.2 Fan and convection heaters are strictly prohibited.",
        ],
      },
      {
        number: "4.3",
        title: "Energy Efficiency",
        items: [
          "4.3.1 Tenants are expected to minimise unnecessary energy use.",
          "4.3.2 Air conditioning must be switched off when the studio is unoccupied.",
        ],
      },
    ],
  },
  {
    number: "5",
    title: "Safety and Security",
    subsections: [
      {
        number: "5.1",
        title: "Fire Safety",
        items: [
          "5.1.1 Tenants must familiarise themselves with the building's fire strategy, evacuation routes and assembly points.",
          "5.1.2 Tenants are responsible for ensuring their staff and guests are also informed.",
          "5.1.3 Tenants with accessibility requirements must complete a PEEP (Personal Emergency Evacuation Plan).",
        ],
      },
      {
        number: "5.2",
        title: "Noise and Disturbance",
        items: [
          "5.2.1 Use of amplified sound, including speakers and music, must remain at background levels (approximately 50–55 dB).",
          "5.2.2 Use of loud machinery or sound systems that disturb others is not permitted, except where specific written permission has been granted prior to occupation.",
        ],
      },
      {
        number: "5.3",
        title: "Smoking Policy",
        items: [
          "5.3.1 Smoking or vaping is not permitted anywhere inside the building or within terraces, internal courtyards or yards.",
          "5.3.2 Smoking is only permitted outside the main entrance of the building.",
        ],
      },
      {
        number: "5.4",
        title: "CCTV",
        items: [
          "5.4.1 CCTV is in operation across most sites for safety and security.",
          "5.4.2 Tenants are advised that areas may be monitored in accordance with GDPR and internal data policies.",
        ],
      },
    ],
  },
  {
    number: "6",
    title: "Access Devices and Entry",
    subsections: [
      {
        number: "6.1",
        title: "Fobs and Codes",
        items: [
          "6.1.1 Access fobs, keys, and codes are issued per studio. These must be handled responsibly.",
          "6.1.2 Codes or fobs must not be shared outside of the Tenant's registered team.",
          "6.1.3 Lost or damaged fobs may incur a replacement cost.",
        ],
      },
      {
        number: "6.2",
        title: "Roller Shutters and Entry Points",
        items: [
          "6.2.1 Where communal roller shutters are in place, users must close them securely after use and store the access device securely.",
          "6.2.2 Any access issues must be reported immediately.",
        ],
      },
    ],
  },
  {
    number: "7",
    title: "Internet",
    subsections: [
      {
        number: "7.1",
        title: "Shared Provision",
        items: [
          "7.1.1 Where internet is provided, this is a basic browsing service and not guaranteed.",
          "7.1.2 Temporary disruptions do not constitute grounds for reimbursement.",
          "7.1.3 Tenants requiring business-critical service must install a dedicated line via approved contractors, subject to SAF approval.",
        ],
      },
    ],
  },
  {
    number: "8",
    title: "Maintenance Responsibilities",
    subsections: [
      {
        number: "8.1",
        title: "Demised Area",
        items: [
          "8.1.1 Tenants are responsible for all internal maintenance of their demised area, including: (a) Light fittings and bulbs; (b) Fixtures and fittings; (c) Any installations made by the Tenant; (d) Any roller shutter serving the unit independently; (e) Any doors and windows of the unit.",
          "8.1.2 Where necessary, Tenants must promptly notify Head Office of any urgent maintenance requirements affecting the building or communal areas.",
        ],
      },
      {
        number: "8.2",
        title: "External or Structural Issues",
        items: [
          "8.2.1 Tenants must under no circumstances make any alterations, attachments, penetrations, or amendments to the exterior, structure, or fabric of the building, including roofs, walls, windows, or external fixtures.",
          "8.2.2 Any such works are strictly prohibited and will be treated as a serious breach of these Building Policies and of the tenancy agreement.",
        ],
      },
    ],
  },
  {
    number: "9",
    title: "Insurance and Liability",
    subsections: [
      {
        number: "9.1",
        title: "Tenant Responsibility",
        items: [
          "9.1.1 Tenants are responsible for obtaining appropriate insurance for: (a) Contents, stock, fixtures and fittings; (b) Public liability, professional indemnity or any other relevant cover.",
          "9.1.2 The landlord does not insure Tenant contents or assume liability for any Tenant operations.",
        ],
      },
      {
        number: "9.2",
        title: "Suitability of Space",
        items: [
          "9.2.1 Tenants must ensure that the space is fit for their business and any employment use.",
          "9.2.2 The landlord does not provide spaces tailored to individual business needs.",
        ],
      },
    ],
  },
  {
    number: "10",
    title: "Parking and Deliveries",
    subsections: [
      {
        number: "10.1",
        title: "Parking",
        items: [
          "10.1.1 Where parking is available, it may be managed by a third-party operator.",
          "10.1.2 Tenants are responsible for compliance with all parking signage.",
          "10.1.3 PCNs issued by third-party operators cannot be appealed via the landlord or its managing agent.",
          "10.1.4 Any issues or disputes arising with parking or the parking management company do not affect the tenancy and remain entirely outside the Landlord's responsibility.",
          "10.1.5 Withholding rent or service charge in relation to parking issues is strictly prohibited and will be treated as a breach of the tenancy.",
        ],
      },
      {
        number: "10.2",
        title: "Deliveries and Mail",
        items: [
          "10.2.1 The landlord does not operate a concierge service.",
          "10.2.2 Deliveries must be managed by the Tenant.",
          "10.2.3 Items left in communal areas are done so at the Tenant's risk and may be considered a fire hazard.",
        ],
      },
    ],
  },
  {
    number: "11",
    title: "Enforcement and Policy Compliance",
    subsections: [
      {
        number: "11.1",
        title: "Contractual Obligation",
        items: [
          "11.1.1 Compliance with these Building Policies forms a contractual part of the Lease or Licence.",
          "11.1.2 Failure to adhere to these policies may result in: (a) Formal written warnings; (b) Penalties or charges applied to the Tenant's account; (c) Remedial action undertaken by the Landlord at the Tenant's cost; (d) In cases of repeated or serious breach, formal enforcement proceedings, which may include termination of the tenancy, eviction, or forfeiture.",
        ],
      },
      {
        number: "11.2",
        title: "Updates and Communication",
        items: [
          "11.2.1 These policies are subject to periodic review.",
          "11.2.2 Updates will be: (a) Posted in entrance lobbies; (b) Available online via QR code; (c) Circulated via email where appropriate.",
        ],
      },
      {
        number: "11.3",
        title: "Inter-Tenant Relations and Disputes",
        items: [
          "11.3.1 The Landlord and/or Managing Agent is not responsible for mediating or resolving disputes between Tenants or between a Tenant and their customers, suppliers, or business associates.",
          "11.3.2 Any commercial or contractual arrangements entered into between Tenants are strictly private matters and fall outside the scope of the tenancy agreement.",
          "11.3.3 The Landlord and/or Managing Agent accepts no liability for any loss, damage, or claim arising from inter-tenant business dealings or disputes.",
          "11.3.4 Tenants must not attempt to involve the Landlord and/or Managing Agent in such matters, nor use them as grounds for withholding rent, service charge, or any other payment.",
        ],
      },
    ],
  },
];

export default function StandardBuildingPolicy() {
  return (
    <main className="pt-16 md:pt-20">
      <section className="max-w-3xl mx-auto px-4 sm:px-6 lg:px-8 py-16">
        <h1 className="text-3xl font-semibold text-gray-900 mb-2">Building Policies</h1>
        <p className="text-sm text-gray-500 mb-4">Issued by Artistic Spaces</p>
        <p className="text-base text-gray-600 leading-relaxed mb-10">
          These Building Policies form part of the Tenant's agreement and must be adhered to at all times. By
          signing a lease or licence, all Tenants confirm they have read, understood, and agreed to comply with
          these policies, which are subject to periodic review and update. The Tenant is also responsible for
          ensuring all staff, contractors, and guests are aware of and comply with these policies.
        </p>

        {/* Contents */}
        <div className="mb-12 border border-gray-200 rounded p-6">
          <h2 className="text-base font-semibold text-gray-900 mb-4">Contents</h2>
          <ol className="flex flex-col gap-1">
            {sections.map((s) => (
              <li key={s.number} className="text-sm text-gray-600">
                <a href={`#section-${s.number}`} className="hover:text-gray-900 transition-colors">
                  {s.number}. {s.title}
                </a>
              </li>
            ))}
          </ol>
        </div>

        {/* Sections */}
        <div className="flex flex-col gap-12">
          {sections.map((section) => (
            <div key={section.number} id={`section-${section.number}`}>
              <h2 className="text-xl font-semibold text-gray-900 mb-6 pb-2 border-b border-gray-200">
                {section.number}. {section.title}
              </h2>
              <div className="flex flex-col gap-6">
                {section.subsections.map((sub) => (
                  <div key={sub.number}>
                    <h3 className="text-base font-semibold text-gray-800 mb-3">
                      {sub.number} {sub.title}
                    </h3>
                    <ul className="flex flex-col gap-2">
                      {sub.items.map((item) => (
                        <li key={item} className="text-base text-gray-600 leading-relaxed">
                          {item}
                        </li>
                      ))}
                    </ul>
                  </div>
                ))}
              </div>
            </div>
          ))}
        </div>
      </section>

      <EnquiryForm pageUri="https://artistic-spaces.co.uk/standard-building-policy" pageName="Standard Building Policy" />
    </main>
  );
}